import { AuctionStatus, XyoWorldAuction } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

import { SortableAuction } from './AuctionSorting'
import { AuctionSortOrder } from './AuctionSortOrder'

export interface MinterAuctions {
  auctions?: XyoWorldAuction[]
  filter?: AuctionStatus
  name?: string
  sortOrder?: AuctionSortOrder
  sortedAuctions?: SortableAuction[]
  update?: (clear?: boolean) => void
  updateFilter?: (filter: AuctionStatus) => void
  updateSortOrder?: (order: AuctionSortOrder) => void
}

export const MinterAuctionsContext = createContext<MinterAuctions>({})
